import { useEffect, useState, useCallback } from 'react';

// Shared fetch pattern for dashboard tiles. Returns { data, loading, error, refresh }.
// Enabled=false short-circuits — useful when a client / date is not yet resolved.
export function useTileData(fetcher, deps, enabled = true) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!enabled) { setData(null); setLoading(false); return; }
    setLoading(true);
    setError(null);
    try {
      setData(await fetcher());
    } catch (e) {
      setError(e?.message || String(e));
      setData(null);
    } finally {
      setLoading(false);
    }
  }, deps);

  useEffect(() => {
    if (!enabled) { setData(null); setLoading(false); setError(null); return; }
    let cancelled = false;
    setLoading(true);
    setError(null);
    Promise.resolve(fetcher())
      .then((r) => { if (!cancelled) setData(r); })
      .catch((e) => { if (!cancelled) { setError(e?.message || String(e)); setData(null); } })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, deps);

  return { data, loading, error, refresh };
}
